import { render } from "./ChartProductosPie.vue?vue&type=template&id=03d85330"
import script from "./ChartProductosPie.vue?vue&type=script&lang=js"
export * from "./ChartProductosPie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__